// extracted by mini-css-extract-plugin
export default {"container":"PmPO71dzy_eN4g_vqpmo__container___","tagPill":"Dr29h8Upq7MFYaGRDgwe__tagPill___"};